/* eslint-disable no-throw-literal */
import {
  GET_CATEGORY_LIST,
  GET_CATEGORY,
  CREATE_MASTER_CATEGORY,
  UPDATE_MASTER_CATEGORY,
  DELETE_CATEGORY
} from './mutation-types'

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_CATEGORY_LIST] ({ dispatch }, params = {}) {
      const res = await dispatch('apiGet', { url: '/master/categories', data: params })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [CREATE_MASTER_CATEGORY] ({ dispatch }, params) {
      const res = await dispatch('apiPost', { url: '/master/categories', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_CATEGORY] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: `/master/categories/${params.id}/edit` })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [DELETE_CATEGORY] ({ dispatch }, params) {
      const res = await dispatch('apiDelete', { url: `/master/categories/${params.id}` })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [UPDATE_MASTER_CATEGORY] ({ dispatch }, params) {
      const res = await dispatch('apiPatch', { url: `/master/categories/${params.data.id}`, data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    }
  },
  mutations: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/category.js